<div class="spinner">
    <div class="icon"></div>
    <div class="message">{{ message }}</div>
</div>
